export enum EnvironmentTypes {
  prd = 'https://cliente.mafrahospitalar.com.br/'
}